import { Drawer, DrawerProps } from '@mui/material'
import { TopBarSectionVisibilityType } from '../../types'
import { MobileLinks, MobileLinksProps } from './mobile-links'
import { MobileLangAndUser } from './mobile-lang-and-user'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles({
  drawer: {
    '& .MuiDrawer-paper': {
      width: 300
    }
  }
})

type MobileMenuProps = Pick<DrawerProps, 'onClose' | 'open'> &
  TopBarSectionVisibilityType &
  MobileLinksProps

export const MobileMenu = ({
  handleMobileMenuClose,
  showLangAndUser,
  showNavigationLinks,
  showUserName,
  useAdminTool,
  ...drawerProps
}: MobileMenuProps) => {
  const classes = useStyles()

  return (
    <Drawer anchor="left" {...drawerProps} className={classes.drawer}>
      {showNavigationLinks && (
        <MobileLinks
          handleMobileMenuClose={handleMobileMenuClose}
          useAdminTool={useAdminTool}
        />
      )}
      {showLangAndUser && <MobileLangAndUser showUserName={showUserName} />}
    </Drawer>
  )
}
